import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]




export default /*#__PURE__*/_defineComponent({
  props: {
    label: null,
    removable: { type: Boolean },
    icon: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["badge d-inline-flex align-items-center px-2", _ctx.$attrs.class]),
    style: {"height":"25px"}
  }, [
    (__props.icon)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(["mr-1", __props.icon])
        }, null, 2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createTextVNode(_toDisplayString(__props.label), 1)
    ]),
    (__props.removable)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "ml-1",
          style: {"cursor":"pointer"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove')))
        }, _hoisted_2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})